import { RichTextEditorControlsWrapper } from 'components/editor/RichTextEditor.styles';
import styled from 'styled-components';

export const ModalContainer = styled.div`
  .editable-area[role='textbox'] {
    height: 150px;
    margin-bottom: 0;
    overflow: auto;
    padding: 6px 12px;
  }

  ${RichTextEditorControlsWrapper} {
    display: none;
  }
`;
